"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SLIDER_STEP_CENTS = void 0;
exports.computeSliderTrackBounds = computeSliderTrackBounds;
exports.clampAndSnapCashAndPayoffCents = clampAndSnapCashAndPayoffCents;
exports.pickBestEligibleOfferIdentifier = pickBestEligibleOfferIdentifier;
/**
 * Granularity of the slider in cents. The HTML range input emits values on
 * this grid starting from `visualMinCents`. Using $1 (100 cents) gives the
 * partner flow fine-grained dragging; the Vue main app overrides this to a
 * coarser step at the call site.
 */
exports.DEFAULT_SLIDER_STEP_CENTS = 100;
/** Compute slider track bounds from a frontend slider config. */
function computeSliderTrackBounds(config) {
    const { minCashAndPayoffCents, maxCashAndPayoffCents, payoffCents } = config;
    const hasPayoffs = payoffCents > 0;
    return {
        visualMinCents: hasPayoffs ? 0 : minCashAndPayoffCents,
        payoffEndsAtCents: payoffCents,
        selectableMinCents: Math.max(payoffCents, minCashAndPayoffCents),
        maxCents: maxCashAndPayoffCents,
    };
}
/**
 * Clamp a `cash + payoff` value into `[selectableMin, max]` and snap to
 * `max` when within one step. The snap exists because `max` comes from
 * `Math.floor(lineSize × (1 − fee − varTax) − fixed)` and is rarely
 * step-aligned with `visualMin`, so without the snap the rightmost reachable
 * value can be a few cents short of the true ceiling.
 */
function clampAndSnapCashAndPayoffCents(value, bounds, stepCents = exports.DEFAULT_SLIDER_STEP_CENTS) {
    const clamped = Math.max(bounds.selectableMinCents, Math.min(value, bounds.maxCents));
    return clamped > bounds.maxCents - stepCents ? bounds.maxCents : clamped;
}
/**
 * Pick the best eligible offer identifier given the per-offer eligibility
 * results. Best = longest term (lowest payment at the same line size). If
 * the current selection is still eligible, keep it; otherwise auto-switch.
 *
 * Returns `null` if no offer is eligible (e.g. payoff exceeds every offer's
 * max line size — typically the slider is in an infeasible state).
 */
function pickBestEligibleOfferIdentifier(offersWithEligibility, currentSelectionIdentifier) {
    const currentStillEligible = offersWithEligibility.find((o) => o.offerIdentifier === currentSelectionIdentifier && o.isEligible);
    if (currentStillEligible) {
        return currentSelectionIdentifier;
    }
    const bestEligible = offersWithEligibility.filter((o) => o.isEligible).sort((a, b) => b.fixedTermMonths - a.fixedTermMonths)[0];
    return bestEligible?.offerIdentifier ?? null;
}
